import { render, staticRenderFns } from "./ahSon.vue?vue&type=template&id=1853ff0a&scoped=true"
import script from "./ahSon.vue?vue&type=script&lang=js"
export * from "./ahSon.vue?vue&type=script&lang=js"
import style0 from "./ahSon.vue?vue&type=style&index=0&id=1853ff0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1853ff0a",
  null
  
)

export default component.exports